import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import { PERMISSIONS, ROLES } from "@/lib/auth/roles";
import PerformanceFirmOverTime from "@/modules/performance/firm-over-time";
import {ELEVATION_FIRM_PERFORMANCE_OVER_TIME_PATH} from "@/utils/urls";

export const Route = createFileRoute(ELEVATION_FIRM_PERFORMANCE_OVER_TIME_PATH)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[PERMISSIONS.IS_NETWORK_VIEW]}
        forbiddenFallback={<Unauthorized/>}>
        <PerformanceFirmOverTime />
      </Authorisation>
    </div>
  )
}
